import { DropdownButton, DropdownButtonType } from '@tableau/widgets';
import React from 'react';

import { Formatters,Messages } from '~src/codegen/Localize';

import { FlowParameter } from '../types/FlowParameters';
import { FlowParametersActions,FlowParametersDialogContent, FlowParametersDialogContentProps } from './FlowParametersDialogContent';

const rootClass: string = 'flowParametersDropdown';
export const flowParametersDropdownId = rootClass + 'Id';

export type FlowParametersDropdownProps = {
  overrideValues?: {[key: string]: string};
  requiredParameters: FlowParameter[];
  additionalParameters: FlowParameter[];
  systemParameters: FlowParameter[];
  actionHandler: (action: FlowParametersActions) => void;
}

export function FlowParametersDropdown(props: FlowParametersDropdownProps): JSX.Element {
  const itemProps: FlowParametersDialogContentProps = {
    ...props,
    isRunNow: false,
  };

  const popupContent = (
    <div role='dialog' id={flowParametersDropdownId}>
      {<FlowParametersDialogContent {...itemProps} />}
    </div>
  );

  return (
    <DropdownButton
      label={undefined}
      aria-controls={flowParametersDropdownId}
      aria-haspopup={'dialog'}
      closeOnPopupBlur={false}
      popupContent={popupContent}
      testId={'FlowParametersDropdownButton'}
      type={DropdownButtonType.Outline}
    >
      {Messages.flowParametersSetParametersLabel({REQUIRED_PARAMETER_COUNT: Formatters.formatCount(props.requiredParameters.length)})}
    </DropdownButton>
  );
}
